import * as React from 'react';
const h = React.createElement;

export type TimelineColor = 'green' | 'red' | 'blue' | 'gray' | 'yellow';

export interface TimelineItemProps {
  color?: TimelineColor;
  children?: React.ReactNode;
}

export interface TimelineProps {
  children?: React.ReactNode;
  className?: string;
}

interface TimelineComponent extends React.FC<TimelineProps> {
  Item: React.FC<TimelineItemProps>;
}

const TimelineBase: React.FC<TimelineProps> = function Timeline(props) {
  const { children, className = '' } = props;
  const items: TimelineItemProps[] = [];
  React.Children.forEach(children, (child) => {
    if (
      React.isValidElement(child) &&
      child.type === (Timeline as unknown as TimelineComponent).Item
    ) {
      items.push(child.props as TimelineItemProps);
    }
  });

  const colorMap: Record<TimelineColor, string> = {
    green: 'bg-green-500',
    red: 'bg-red-500',
    blue: 'bg-blue-500',
    gray: 'bg-dark-500',
    yellow: 'bg-yellow-500',
  };

  return h(
    'div',
    { className },
    items.map((item, i) =>
      h(
        'div',
        { key: i, className: 'flex gap-4 pb-4 last:pb-0' },
        h(
          'div',
          { className: 'flex flex-col items-center' },
          h('div', {
            className: `w-2.5 h-2.5 rounded-full shrink-0 ${(item.color && colorMap[item.color]) || colorMap.gray}`,
          }),
          i < items.length - 1 && h('div', { className: 'w-px flex-1 bg-dark-700 mt-1' }),
        ),
        h('div', { className: 'flex-1 -mt-0.5' }, item.children),
      ),
    ),
  );
};

const Timeline = TimelineBase as TimelineComponent;

Timeline.Item = function TimelineItem(_props) {
  return null;
};

export { Timeline };
